import { FEED_INEVIDENZA, feedInEvidenzaActionType, InEvidenza } from 'lib/ssr/sport/in-evidenza/types';

export const feedInEvidenza = (payload: InEvidenza): feedInEvidenzaActionType => ({
  type: FEED_INEVIDENZA,
  payload,
});